// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"356":"css/payslip","460":"css/dropzone","663":"css/core","999":"css/fontawesome"}[chunkId] + ".css";
};